import axios from 'axios';
import ReactPaginate from 'react-paginate'
import React, { Component } from 'react'
import "../../services/ApiRest";
import swal from 'sweetalert';
import { ApiUrl } from '../../services/ApiRest';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';

const urlListarEstudCarrPeriod = ApiUrl + "listestudmatriperiodcarr" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarAsignaturas = ApiUrl + "listasignmatrireport" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListPeriodos = ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarCarreras = ApiUrl + "listarcarreras" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

let listaauxiliar = [];
const itemsPerPage = 10;

export default class CalificacionesEstudDetall extends Component {

    constructor(props) {
        super(props)
        this.state = {
            carrera: [],
            estado: "",
            listasignaturas: [],
            listaperiodos: [],
            idPeriodo: 1,
            form1: {
            },
            //Variables para búsqueda
            estud: [],
            EstudianteBackup: [],
            textBuscar: "",
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
        }
        this.handleChange = this.handleChange.bind(this);
        this.escFunction = this.escFunction.bind(this);
    }
    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({ modalReportAsignatutasEst: false });
        }
    }
    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ estado: "" });
    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, true);
        //Listar las carreras
        axios.get(urlListarCarreras)
            .then(res => {
                const carrera = res.data;
                this.setState({ carrera });
            })

        //listar todos los periodos
        axios
            .get(urlListPeriodos)
            .then(response => {
                const listaperiodos = response.data.data;
                const cant = listaperiodos.length;
                if (cant != 0) {
                    this.setState({ listaperiodos });
                }
            })
    }

    //BUSQUEDA......
    filter(event) {
        console.log(event.target.value);
        //obtener datos de buscar
        var text = event.target.value
        //obtener datos del array
        const data = this.state.estud
        var newData = data.filter(function (item) {
            //variable del objeto
            const itemDataPrimerApell = item.primer_apellido_estudiante.toUpperCase()
            const itemDataPrimerNom = item.primer_nombre_estudiante.toUpperCase()
            const itemDataCedula = item.numero_identificacion_estudiante.toUpperCase()
            const campo = itemDataPrimerApell + " " + itemDataPrimerNom + " " + itemDataCedula; //variable del buscador
            const textData = text.toUpperCase()
            return campo.indexOf(textData) > -1

        })
        if (text == "") {
            newData = this.state.EstudianteBackup;
        }
        this.setState({
            currentItems: newData,
            textBuscar: text,
        })

    }
    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ EstudianteBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
    }

    //Mostrar las asignaturas matriculadas de un estudiante
    mostrarAsignaturasMat = (registro) => {
        axios.post(urlListarAsignaturas, {
            idEstudiante: registro.id_estudiante,
            idPeriodo: this.state.idPeriodo,
            idCarrera: this.state.idCarrera
        })
            .then(response => {
                if (response.data.success === true) {
                    const listasignaturas = response.data.data;
                    this.setState({ listasignaturas });
                }
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
        this.setState({ modalReportAsignatutasEst: true, form1: registro });
    }

    ocultarModalReportAsignaturas = () => {
        this.setState({ modalReportAsignatutasEst: false });
    }
    //Listas estudiamntes matriculados en un periodo y carrera
    handleChangeEstudCarrera = () => {
        axios.post(urlListarEstudCarrPeriod, {
            idPeriodSelect: this.state.idPeriodo,
            idCarreraSelect: this.state.idCarrera
        })
            .then(respuesta => {

                if (respuesta.data.success == true) {
                    listaauxiliar = respuesta.data.data;

                    const estud = respuesta.data.data;
                    this.setState((state) => {
                        return { estud: estud }
                    }
                    );
                    const EstudianteBackup = estud;
                    this.setState((state) => {
                        return { EstudianteBackup: EstudianteBackup }
                    });
                    //PAGINACION
                    this.state.itemOffset = 0;
                    const endOffset = this.state.itemOffset + itemsPerPage;
                    this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                    this.setState((state) => {
                        return { itemOffset: state.itemOffset + endOffset }
                    });
                    //FIN  DE LA PAGINACION
                } else {
                    this.setState({ error: "¡No existe información!" });
                    swal({
                        text: "¡No existe información!",
                        icon: "info",
                        button: "Aceptar",
                    });
                }
            })
    }

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0">
                    <div className="back-istmas d-flex align-items-center">
                        <i className="far fa-sticky-note me-2"></i>
                        <b className="mb-0 fw-semibold">Calificaciones de los estudiantes</b>
                    </div>

                    <div className="p-3 rounded-3">
                        {/* Filtros */}
                        <div className="row g-3 mb-3">
                            {/* Buscar */}
                            <div className="col-12 col-md-3">
                                <label className="form-label text-azul small">
                                    <i className="fa fa-search me-1"></i> Buscar
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={this.state.text}
                                    placeholder="Buscar..."
                                    onChange={text => this.filter(text)}
                                />
                            </div>

                            {/* Período */}
                            <div className="col-12 col-md-3">
                                <label className="form-label text-azul small">
                                    <i className="fa fa-calendar me-1"></i> Período
                                </label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idPeriodo"
                                    value={this.state.idPeriodo}
                                    onChange={this.handleChange}
                                >
                                    <option value="undefined" selected disabled>Seleccione el período</option>
                                    {this.state.listaperiodos.map(p => (
                                        <option key={p.id_periodo_academico} value={p.id_periodo_academico}>
                                            {p.descripcion_periodo_academico}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Carrera */}
                            <div className="col-12 col-md-3">
                                <label className="form-label text-azul small">Carrera</label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idCarrera"
                                    value={this.state.idCarrera}
                                    onChange={this.handleChange}
                                >
                                    <option value="undefined" selected disabled>Seleccione una carrera</option>
                                    {this.state.carrera.map(c => (
                                        <option key={c.id_carrera} value={c.id_carrera}>
                                            {c.descripcion_carrera}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Botón Consultar */}
                            <div className="col-12 col-md-3 d-flex align-items-end">
                                <button
                                    className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm w-100"
                                    onClick={this.handleChangeEstudCarrera}
                                >
                                    Consultar
                                </button>
                            </div>
                        </div>

                        {/* Tabla de resultados */}
                        <h6 className="fw-bold text-center mb-3 text-azul small">
                            Calificaciones de los estudiantes
                        </h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-hover align-middle small">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-azul">Cédula</th>
                                        <th className="text-azul">Primer Apellido</th>
                                        <th className="text-azul">Segundo Apellido</th>
                                        <th className="text-azul">Primer Nombre</th>
                                        <th className="text-azul">Segundo Nombre</th>
                                        <th className="text-azul">Calificaciones</th>
                                    </tr>
                                </thead>
                                <tbody className="text-azul">
                                    {this.state.currentItems?.map(consola => (
                                        <tr className="list-afiliados" key={consola.id_estudiante}>
                                            <td>{consola.numero_identificacion_estudiante}</td>
                                            <td>{consola.primer_apellido_estudiante}</td>
                                            <td>{consola.segundo_apellido_estudiante}</td>
                                            <td>{consola.primer_nombre_estudiante}</td>
                                            <td>{consola.segundo_nombre_estudiante}</td>
                                            <td>
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() => this.mostrarAsignaturasMat(consola)}
                                                >
                                                    <i className="fas fa-clipboard-check"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Modal de asignaturas */}
                        <Modal size="lg" isOpen={this.state.modalReportAsignatutasEst}>
                            <ModalHeader>
                                <div className="small mb-0 text-white">
                                    {[
                                        this.state.form1.primer_apellido_estudiante,
                                        this.state.form1.segundo_apellido_estudiante,
                                        this.state.form1.primer_nombre_estudiante,
                                        this.state.form1.segundo_nombre_estudiante
                                    ].join(' ')}
                                </div>
                            </ModalHeader>
                            <ModalBody>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-sm small">
                                        <thead className="table-light">
                                            <tr>
                                                <th className="text-azul">Código</th>
                                                <th className="text-azul">Asignatura</th>
                                                <th className="text-azul">Nivel</th>
                                                <th className="text-azul">No Matrícula</th>
                                                <th className="text-azul">Paralelo</th>
                                                <th className="text-azul">P1 (10)</th>
                                                <th className="text-azul">P2 (10)</th>
                                                <th className="text-azul">P3 (10)</th>
                                                <th className="text-azul">Prom. Parc (6)</th>
                                                <th className="text-azul">Examen F (4)</th>
                                                <th className="text-azul">Prom. Acum (10)</th>
                                                <th className="text-azul">Exam. Susp (10)</th>
                                                <th className="text-azul">Prom. Final (10)</th>
                                                <th className="text-azul">Estado</th>
                                                <th className="text-azul">Asistencia (%)</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-azul">
                                            {this.state.listasignaturas.map(item => (
                                                <tr key={item.id_asignatura}>
                                                    <td>{item.codigo_asignatura}</td>
                                                    <td>{item.descripcion_asignatura}</td>
                                                    <td>{item.nivel_asignatura}</td>
                                                    <td>{item.tipo_matricula_asignatura}</td>
                                                    <td>{item.nombre_paralelo}</td>
                                                    <td>{item.parcial1}</td>
                                                    <td>{item.parcial2}</td>
                                                    <td>{item.parcial3}</td>
                                                    <td>
                                                        {(((item.parcial1 + item.parcial2 + item.parcial3) * 6) / 30)
                                                            .toFixed(2)}
                                                    </td>
                                                    <td>{((item.examen_final * 4) / 10).toFixed(2)}</td>
                                                    <td>
                                                        {(
                                                            ((item.parcial1 + item.parcial2 + item.parcial3) * 6) / 30 +
                                                            ((item.examen_final * 4) / 10)
                                                        ).toFixed(2)}
                                                    </td>
                                                    <td>{item.examen_suspension}</td>
                                                    <td>
                                                        {(() => {
                                                            const pParc =
                                                                ((item.parcial1 + item.parcial2 + item.parcial3) * 6) / 30;
                                                            const pExa = ((item.examen_final * 4) / 10);
                                                            const total = pParc + pExa;
                                                            if (total < 7 && item.examen_suspension > 0) {
                                                                return ((total + item.examen_suspension) / 2).toFixed(2);
                                                            }
                                                            return total.toFixed(2);
                                                        })()}
                                                    </td>
                                                    <td>
                                                        {item.equivalencia === 0 ? "REPROBADO" :
                                                            item.equivalencia === 1 ? "APROBADO" : ""}
                                                    </td>
                                                    <td>{item.asistencia}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <button
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={this.ocultarModalReportAsignaturas}
                                >
                                    Salir
                                </button>
                            </ModalFooter>
                        </Modal>

                        {/* Paginador */}
                        <div className="d-flex justify-content-center mt-3">
                            <ReactPaginate
                                nextLabel=">"
                                previousLabel="<"
                                onPageChange={this.handlePageClick}
                                pageRangeDisplayed={5}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                containerClassName="pagination pagination-sm-custom"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                activeClassName="active"
                                renderOnZeroPageCount={null}
                            />
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}
